import React, { Children, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Carousel } from 'components/core/Carousel';
import { Image } from 'components/core/Image';

import './imageCarousel.scss';

export function ImageCarousel({
	images = [],
	className,
	preload = false
}) {
	useEffect(() => {
		if (preload && images && images.length > 0) {
			const preloadLink = document.createElement('link');
			preloadLink.rel = 'preload';
			preloadLink.as = 'image';
			preloadLink.href = images[0].src;
			document.head.appendChild(preloadLink);
		}
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<div className="carousel-container">
			<Carousel
				className={classnames('ph-image-carousel', className)}
			>
				{!!images.length && Children.toArray(images.map((image) => (
					<Image
						src={image.src}
						alt={image.alt}						
					/>
				)))}
			</Carousel>
		</div>
	);
}

ImageCarousel.propTypes = {
	className: PropTypes.string,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string.isRequired,
			alt: PropTypes.string
		})
	),
	preload: PropTypes.bool,
};

export default ImageCarousel;
